import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Bienvenido/a ✦`);
      if (u.must_change_password) navigate("/admin/cambiar-clave");
      else if (u.role === "cajero") navigate("/admin/pos");
      else navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-5">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <div className="font-display text-5xl tracking-[0.15em] text-espresso">MO</div>
          <span className="font-serif italic text-rose text-lg">by Vir</span>
          <p className="text-[11px] uppercase tracking-[0.25em] text-taupe mt-4">
            Panel de administración
          </p>
        </div>

        <form onSubmit={submit} className="space-y-6">
          <div>
            <label className="text-[11px] uppercase tracking-[0.2em] text-taupe">
              Correo o usuario
            </label>
            <input
              data-testid="admin-email"
              type="text"
              autoCapitalize="none"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mt-2 bg-transparent border-b border-line py-3 focus:outline-none focus:border-rose transition-colors font-light"
            />
          </div>
          <div>
            <label className="text-[11px] uppercase tracking-[0.2em] text-taupe">
              Contraseña
            </label>
            <input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full mt-2 bg-transparent border-b border-line py-3 focus:outline-none focus:border-rose transition-colors font-light"
            />
          </div>
          <button
            data-testid="admin-login-btn"
            type="submit"
            disabled={loading}
            className="w-full bg-espresso text-cream rounded-full py-4 text-xs uppercase tracking-[0.2em] hover:bg-rose transition-colors disabled:opacity-60"
          >
            {loading ? "Ingresando..." : "Ingresar"}
          </button>
        </form>

        <button
          onClick={() => navigate("/")}
          className="mt-8 mx-auto block text-taupe text-[11px] uppercase tracking-[0.2em] hover:text-espresso transition-colors"
        >
          ← Volver a la tienda
        </button>
      </div>
    </div>
  );
}
